import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { deletePlate } from 'services/payments-service';
import { TableExt, TableInfo, Confirm, themes, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import PlateForm from './forms/plate-form';
import { getTableParams } from './grid.params';

export const PlateGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry } = props;
  // Object.keys(entries).forEach((el) => {
  //   if (entries[el].data.violations_count > 0) {
  //     console.log(entries[el].vehicle_plate, entries[el].data.violations_count);
  //   }
  // });
  const [showForm, setShowForm] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  const { t } = useTranslation();

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  /**
   * delete item
   */
  const delItem = (id) => {
    deletePlate(id).then(() => {
      props.getEntries({ offset: 0 }, null, true);
      closeConfirm();
    });
  };

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  const delItemAction = (row) => {
    setRow(row);
    setConfirm({
      title: t('messages.СО') + ' ' + row.mean_id + ' ' + t('messages.будет удалено. Продолжить?'),
      width: '440px',
      type: 'danger',
      cancelButton: { text: t('buttons.Отмена'), func: closeConfirm },
      acceptButton: { text: t('buttons.Удалить'), func: () => delItem(row.id), theme: themes.red },
    });
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('plates.update');
  const rightDel = user.haveRight('plates.delete');
  const rightAdd = user.haveRight('plates.add');
  const actions = [];
  if (rightDel) {
    actions.push({ title: t('buttons.Удалить'), action: delItemAction });
  }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }
  if (count) {
    getXlsAction(topActions);
  }

  const initial = showForm === 'addForm' ? {} : { ...row };
  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('plate', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.ГРЗ')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...restTableParams}
        fields={fields}
        updateEntry={updateEntry}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && (
        <PlateForm
          type={showForm}
          close={() => setShowForm('')}
          clientId={props.clientId}
          id={row.id}
          meanId={row.mean_id}
          meanType={row.mean_type}
          refresh={props.refresh}
          initialValues={initial}
          tariffs={props.tariffs}
        />
      )}
    </GridBox>
  );
};
